import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";

const coresMapeadas = {
  whatsapp: "#25D366",
  instagram: "#E1306C",
  facebook: "#1877F2",
  tiktok: "#010101",
  twitter_x: "#000000",
  geolocalizacao: "#6366F1",
  endereco: "#8B5CF6",
  telefone: "#0EA5E9",
};

const CliquesLinks = ({ cliques = [] }) => {
  const porCategoria = Object.values(
    cliques.reduce((acc, link) => {
      const categoria = link.categoria || link.tipo;
      if (!acc[categoria]) {
        acc[categoria] = { tipo: categoria, total: 0 };
      }
      acc[categoria].total += link.total || 0;
      return acc;
    }, {})
  );

  const cores = porCategoria.map((link) => coresMapeadas[link.tipo] || "#8884d8");

  return (
    <div className="bg-white rounded-2xl shadow p-4 my-4">
      <h3 className="text-sm font-semibold text-gray-600 mb-2">Cliques em links</h3>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={porCategoria}
            dataKey="total"
            nameKey="tipo"
            cx="50%"
            cy="50%"
            outerRadius={60}
            fill="#8884d8"
            label
          >
            {porCategoria.map((_, index) => (
              <Cell key={`cell-${index}`} fill={cores[index]} />
            ))}
          </Pie>
          <Legend verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>

      {cliques.length ? (
        <div className="mt-3 border-t border-gray-100 pt-3">
          <p className="text-xs font-semibold text-gray-500 mb-2">Top links</p>
          <div className="space-y-2">
            {[...cliques]
              .sort((a, b) => b.total - a.total)
              .slice(0, 5)
              .map((link, idx) => (
                <div
                  key={`${link.categoria}-${link.tipo}-${idx}`}
                  className="flex items-center justify-between text-sm"
                >
                  <span className="text-gray-700 truncate pr-2">{link.tipo}</span>
                  <span className="font-semibold text-gray-900">{link.total}</span>
                </div>
              ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CliquesLinks;
